import { useSettingsStore } from '../settings/stores/settings-store';

export const TRANSLATIONS = {
    ko: {
        // General
        common: {
            confirm: '확인',
            cancel: '취소',
            save: '저장',
            delete: '삭제',
            edit: '편집',
            loading: '로딩 중...',
        },
        // Toolbar / Editor Header
        toolbar: {
            selectTool: '선택 도구 (V)',
            razorTool: '자르기 도구 (C)',
            rateStretchTool: '배속 도구 (R)',
            undo: '실행 취소 (Ctrl+Z)',
            redo: '다시 실행 (Ctrl+Shift+Z)',
            zoomIn: '확대',
            zoomOut: '축소',
            fitTimeline: '타임라인 맞춤',
            toggleTheme: '밝은/어두운 모드 전환',
            language: '언어 설정',
            showTimeline: '타임라인 펴기',
            hideTimeline: '타임라인 접기',
        },
        // Templates Panel
        templates: {
            title: '템플릿',
            tabBasic: '기본',
            tabIssue: '이슈',
            tabSsul: '썰',
            tabSns: 'SNS',
            tabMy: 'My',
            applyToAll: '현재 스타일 전체 적용 (변경확정)',
            saveMyTemplate: '내 템플릿 저장',
            registerCloud: '공용 등록',
            presetsTitle: '프리셋',
        },
        // Timeline
        timeline: {
            title: '타임라인',
            tracks: '트랙',
            trackPrefix: '트랙',
            tracksLabel: 'Tracks',
            video: '비디오',
            audio: '오디오',
            text: '텍스트',
            adjustment: '조정 레이어',
            emptyText: '비어 있는 텍스트',
            effects: '효과',
            visibility: '표시 전환',
            mute: '음소거 전환',
            solo: '솔로 전환',
            lock: '잠금 전환',
            setInPoint: '시작점 설정 (I)',
            setOutPoint: '종료점 설정 (O)',
            clearInOut: '시작/종료점 해제',
            addMarker: '마커 추가 (M)',
            removeMarker: '선택된 마커 삭제',
            clearMarkers: '모든 마커 삭제',
            snapEnabled: '스냅 활성화됨',
            snapDisabled: '스냅 비활성화됨',
            showGraph: '키프레임 그래프 보기',
            hideGraph: '키프레임 그래프 숨기기',
        },
        // Properties Sidebar
        properties: {
            title: '속성',
            source: '소스',
            file: '파일',
            duration: '길이',
            transform: '변형',
            effects: '효과',
            media: '미디어',
            layout: '레이아웃',
            fill: '채우기',
            opacity: '불투명도',
            radius: '둥글기',
            position: '위치',
            rotation: '회전',
            fit: '맞춤',
            contain: '포함',
            cover: '채우기',
            animationPresets: '애니메이션 프리셋',
            zoomIn: '확대 (Zoom In)',
            zoomOut: '축소 (Zoom Out)',
            panRight: '오른쪽으로 팬',
            panLeft: '왼쪽으로 팬',
            panUp: '위로 팬',
            panDown: '아래로 팬',
            clearAnimations: '모든 애니메이션 삭제',
            text: '텍스트',
            content: '내용',
            font: '글꼴',
            size: '크기',
            weight: '굵기',
            align: '정렬',
            color: '색상',
            spacing: '자간',
            lineHeight: '행간',
            background: '배경',
            applyToAllTitles: '모든 제목에 스타일 적용',
            applyToAllCaptions: '모든 캡션에 스타일 적용',
            enterText: '텍스트 입력...',
            selectFont: '글꼴 선택',
            selectWeight: '굵기 선택',
            caption: '자막 (Caption)',
            titleLabel: '제목 (Title)',
            shape: '도형',
            type: '종류',
            strokeWidth: '선 두께',
            strokeColor: '선 색상',
            points: '꼭짓점',
            innerRadius: '내부 반경',
            useAsMask: '마스크로 사용',
            maskType: '마스크 종류',
            feather: '페더 (Feather)',
            invert: '반전',
            rectangle: '사각형',
            circle: '원형',
            triangle: '삼각형',
            ellipse: '타원',
            star: '별',
            polygon: '다각형',
            heart: '하트',
            clipHard: '클립 (단단한 테두리)',
            alphaSoft: '알파 (부드러운 테두리)',
            direction: '방향',
            up: '위',
            down: '아래',
            left: '왼쪽',
            right: '오른쪽',
            selectShape: '도형 선택',
            selectType: '종류 선택',
            audio: '오디오',
            gain: '음량 (Gain)',
            fadeIn: '페이드 인',
            fadeOut: '페이드 아웃',
            resetToZero: '0으로 초기화',
            video: '비디오',
            speed: '속도 (Speed)',
            resetToOne: '1배속으로 초기화',
            gif: 'GIF 애니메이션',
            resetOpacity: '불투명도 100%로 초기화',
            resetRadius: '0으로 초기화',
            resetPosition: '중앙으로 초기화',
            resetRotation: '회전 초기화 (0°)',
            resetSize: '원본 크기로 초기화',
            lockAspect: '비율 유지 잠금',
            unlockAspect: '비율 유지 해제',
            alignLeft: '왼쪽 정렬',
            alignCenterH: '가로 중앙 정렬',
            alignRight: '오른쪽 정렬',
            alignTop: '위쪽 정렬',
            alignCenterV: '세로 중앙 정렬',
            alignBottom: '아래쪽 정렬',
            selection: '선택됨',
            itemsSelected: '개의 항목 선택됨',
            adjustmentInfo: '조정 레이어의 효과는 상위 트랙의 모든 항목에 적용됩니다.',
            canvas: '캔버스',
            swap: '전환',
            reset: '초기화',
            resetToBlack: '검정색으로 초기화',
            frameRate: '프레임 속도',
            totalFrames: '총 프레임',
            noProject: '불러온 프로젝트가 없습니다.',
            marker: '마커',
            markerNotFound: '마커를 찾을 수 없습니다.',
            deleteMarker: '마커 삭제',
            frame: '프레임',
            time: '시간',
            enterLabel: '이름 입력...',
            transition: '전환 (Transition)',
            transitionNotFound: '전환 효과를 찾을 수 없습니다.',
            timing: '타이밍',
            linear: '선형 (Linear)',
            spring: '스프링 (Spring)',
            applyToAll: '모든 전환에 적용',
            deleteTransition: '전환 삭제',
            categoryBasic: '기본',
            categoryWipe: '와이프',
            categorySlide: '슬라이드',
            categoryFlip: '플립',
            categorySpecial: '스페셜',
            templates: '템플릿',
            exportState: '현재 상태 내보내기',
            exportDescription: '디자인을 수정한 후 이 버튼을 눌러 JSON을 복사하세요.',
        },
        // Sidebar & Media Library
        sidebar: {
            media: '미디어',
            text: '텍스트',
            shapes: '도형',
            effects: '효과',
            transitions: '전환',
            templates: '템플릿',
            collapse: '패널 접기',
            expand: '패널 펼치기',
            addText: '텍스트 추가',
            blankAdjustment: '빈 조정 레이어',
            addEffectsManually: '수동으로 효과 추가',
            colorAdjustments: '색상 조절',
            glitchEffects: '글리치 효과',
            stylized: '스타일',
            presets: '프리셋',
            searchTransitions: '전환 효과 검색...',
            searchMedia: '미디어 검색...',
            import: '가져오기',
            missing: '누락됨',
            itemsSelected: '개 선택됨',
            clearSelection: '선택 해제',
            delete: '삭제',
            all: '전체',
            video: '비디오',
            image: '이미지',
            audio: '오디오',
            sortName: '이름순',
            sortDate: '날짜순',
            sortSize: '크기순',
            viewGrid: '그리드 보기',
            viewList: '리스트 보기',
            noAdjacentClip: '인접한 클립을 찾을 수 없습니다. 타임라인에서 클립을 서로 붙여주세요.',
            selectSingleClip: '전환 효과를 추가하려면 단일 비디오 또는 이미지 클립을 선택하세요.',
            clickToApply: '전환 효과를 클릭하여 적용하세요 (기존 항목은 업데이트됨).',
            confirmDeleteMedia: '선택한 항목을 삭제할까요?',
            deleteMediaDescription: '선택한 항목을 정말로 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
            timelineClipsRemoved: '타임라인 클립이 삭제됩니다',
            timelineClipsImpact: (count: number) => `타임라인에 있는 ${count}개의 클립이 이 미디어를 사용하고 있으며 함께 삭제됩니다.`,
        },
        // Effects labels
        effects: {
            brightness: '밝기',
            contrast: '대비',
            saturate: '채도',
            blur: '블러',
            hueRotate: '색상 회전',
            grayscale: '그레이스케일',
            sepia: '세피아',
            invert: '반전',
            rgbSplit: 'RGB 분할',
            scanlines: '스캔라인',
            colorGlitch: '컬러 글리치',
            halftone: '하프톤',
            vignette: '비네트',
            vintage: '빈티지',
            noir: '느와르',
            cold: '차가운',
            warm: '따뜻한',
            dramatic: '드라마틱',
            faded: '바랜 느낌',
        },
        // Settings Dialog
        settings: {
            title: '에디터 설정',
            reset: '초기화',
            general: '일반',
            autoSave: '자동 저장',
            interval: '간격',
            timeline: '타임라인',
            showWaveforms: '오디오 파형 표시',
            showFilmstrips: '필름스트립 표시',
            performance: '성능',
            undoHistoryDepth: '실행 취소 히스토리 깊이',
            storage: '저장소',
            clearProjectCache: '프로젝트 캐시 지우기',
            cacheDescription: '오디오 파형, 필름스트립, GIF 프레임, 디코딩된 오디오 데이터',
            regenerateThumbnails: '썸네일 재생성',
            regenDescription: '미디어 라이브러리 썸네일을 다시 생성합니다.',
            deleteProxies: '프록시 삭제',
            proxyDescription: '생성된 프록시 영상을 삭제합니다.',
            clear: '지우기',
            clearing: '지우는 중...',
            cleared: '완료',
            regenerate: '재생성',
            working: '진행 중',
            done: '완료',
            delete: '삭제',
            deleting: '삭제 중...',
            deleted: '삭제됨',
            confirmClearCache: '프로젝트 캐시를 지우시겠습니까?',
            clearCacheDescription: '현재 프로젝트의 오디오 파형, 필름스트립, GIF 프레임 및 디코딩된 오디오 데이터가 삭제됩니다. 필요시 자동으로 다시 생성됩니다.',
        },
        // Unsaved Changes Dialog
        unsavedChanges: {
            title: '저장되지 않은 변경사항',
            description: (title: string) => `'${title}' 프로젝트에 저장되지 않은 변경사항이 있습니다. 나가기 전에 저장하시겠습니까?`,
            cancel: '취소',
            discard: '삭제',
            saveAndExit: '저장 후 나가기',
        },
        // Dashboard / Projects
        dashboard: {
            searchPlaceholder: '프로젝트 검색...',
            allResolutions: '모든 해상도',
            allFps: '모든 FPS',
            importProject: '프로젝트 가져오기',
            newProject: '새 프로젝트',
            projectCount: (count: number) => `${count}개의 프로젝트`,
        },
        // Preview
        preview: {
            totalDuration: '전체 길이',
            toggleTimecode: '타임코드/프레임 전환',
        },
        // Export
        export: {
            titleVideo: '비디오 내보내기',
            titleAudio: '오디오 내보내기',
            exportingVideo: '비디오 내보내는 중...',
            exportingAudio: '오디오 내보내는 중...',
            complete: '내보내기 완료!',
            failed: '내보내기 실패',
            cancelled: '내보내기 취소됨',
            settingsDescription: '내보내기 설정을 구성하고 비디오를 렌더링합니다.',
            progressDescription: '비디오 렌더링 중',
            completeDescription: '비디오 다운로드 준비 완료',
            errorDescription: '내보내기 중 문제가 발생했습니다.',
            cancelledDescription: '내보내기가 취소되었습니다.',
            exportType: '내보내기 종류',
            video: '비디오',
            audio: '오디오',
            range: '내보내기 구간',
            renderWhole: '전체 프로젝트 렌더링',
            duration: '길이',
            rangeHint: '시작/종료 구간을 내보내는 중입니다. 타임라인 전체를 내보내려면 위 스위치를 켜세요.',
            format: '형식',
            selectFormat: '형식 선택',
            codec: '코덱',
            selectCodec: '코덱 선택',
            quality: '품질',
            selectQuality: '품질 선택',
            qualityLow: '낮음 (빠름, 작은 파일 크기)',
            qualityMedium: '중간',
            qualityHigh: '높음 (권장)',
            qualityUltra: '울트라 (느림, 큰 파일 크기)',
            resolution: '해상도',
            selectResolution: '해상도 선택',
            resSameAsProject: '프로젝트와 동일',
            formatDescriptionMp4: '가장 호환성이 높음, H.264/H.265',
            formatDescriptionMov: 'macOS/iOS에 최적화됨',
            formatDescriptionWebm: '웹 최적화, VP8/VP9',
            formatDescriptionMkv: '유연한 포맷, 모든 코덱 지원',
            formatDescriptionMp3: '범용적, 작은 파일 크기',
            formatDescriptionAac: '고품질, 압축률 좋음',
            formatDescriptionWav: '무손실, 큰 파일 크기',
            audioOnlyNotice: '오디오만 내보냅니다. 비디오 트랙은 무시됩니다.',
            audioQualityLow: '낮음 (96 kbps)',
            audioQualityMedium: '중간 (192 kbps)',
            audioQualityHigh: '높음 (256 kbps)',
            audioQualityUltra: '울트라 (320 kbps)',
            preparing: '준비 중...',
            rendering: '프레임 렌더링 중...',
            encoding: '인코딩 중...',
            finalizing: '마무리 중...',
            frames: '프레임:',
            elapsed: '경과 시간:',
            tabOpenHint: '렌더링하는 동안 이 탭을 열어 두세요. 긴 비디오는 몇 분 정도 걸릴 수 있습니다.',
            cancelExport: '내보내기 취소',
            successAlert: '비디오를 성공적으로 내보냈습니다!',
            fileSize: '파일 크기:',
            timeTaken: '소요 시간:',
            close: '닫기',
            download: '다운로드',
            cancelProcess: '내보내기 프로세스가 취소되었습니다.',
        }
    },
    en: {
        // General
        common: {
            confirm: 'Confirm',
            cancel: 'Cancel',
            save: 'Save',
            delete: 'Delete',
            edit: 'Edit',
            loading: 'Loading...',
        },
        // Toolbar / Editor Header
        toolbar: {
            selectTool: 'Select Tool (V)',
            razorTool: 'Razor Tool (C)',
            rateStretchTool: 'Rate Stretch Tool (R)',
            undo: 'Undo (Ctrl+Z)',
            redo: 'Redo (Ctrl+Shift+Z)',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out',
            fitTimeline: 'Fit to Timeline',
            toggleTheme: 'Toggle Bright/Dark Mode',
            language: 'Language Settings',
            showTimeline: 'Show Timeline',
            hideTimeline: 'Hide Timeline',
        },
        // Templates Panel
        templates: {
            title: 'Templates',
            tabBasic: 'Basic',
            tabIssue: 'Issue',
            tabSsul: 'Story',
            tabSns: 'SNS',
            tabMy: 'My',
            applyToAll: 'Apply Current Style to All',
            saveMyTemplate: 'Save My Template',
            registerCloud: 'Register to Cloud',
            presetsTitle: 'Presets',
        },
        // Timeline
        timeline: {
            title: 'Timeline',
            tracks: 'Tracks',
            trackPrefix: 'Track',
            tracksLabel: 'Tracks',
            video: 'Video',
            audio: 'Audio',
            text: 'Text',
            adjustment: 'Adjustment Layer',
            emptyText: 'Empty text',
            effects: 'effects',
            visibility: 'Toggle Visibility',
            mute: 'Toggle Mute',
            solo: 'Toggle Solo',
            lock: 'Toggle Lock',
            setInPoint: 'Set In Point (I)',
            setOutPoint: 'Set Out Point (O)',
            clearInOut: 'Clear In/Out Points',
            addMarker: 'Add Marker (M)',
            removeMarker: 'Remove Selected Marker',
            clearMarkers: 'Clear All Markers',
            snapEnabled: 'Snap Enabled',
            snapDisabled: 'Snap Disabled',
            showGraph: 'Show Keyframe Graph',
            hideGraph: 'Hide Keyframe Graph',
        },
        // Properties Sidebar
        properties: {
            title: 'Properties',
            source: 'Source',
            file: 'File',
            duration: 'Duration',
            transform: 'Transform',
            effects: 'Effects',
            media: 'Media',
            layout: 'Layout',
            fill: 'Fill',
            opacity: 'Opacity',
            radius: 'Radius',
            position: 'Position',
            rotation: 'Rotation',
            fit: 'Fit',
            contain: 'Contain',
            cover: 'Cover',
            animationPresets: 'Animation Presets',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out',
            panRight: 'Pan Right',
            panLeft: 'Pan Left',
            panUp: 'Pan Up',
            panDown: 'Pan Down',
            clearAnimations: 'Clear All Animations',
            text: 'Text',
            content: 'Content',
            font: 'Font',
            size: 'Size',
            weight: 'Weight',
            align: 'Align',
            color: 'Color',
            spacing: 'Spacing',
            lineHeight: 'Line Height',
            background: 'Background',
            applyToAllTitles: 'Apply style to all titles',
            applyToAllCaptions: 'Apply style to all captions',
            enterText: 'Enter text...',
            selectFont: 'Select font',
            selectWeight: 'Select weight',
            caption: 'Caption',
            titleLabel: 'Title',
            shape: 'Shape',
            type: 'Type',
            strokeWidth: 'Stroke Width',
            strokeColor: 'Stroke Color',
            points: 'Points',
            innerRadius: 'Inner Radius',
            useAsMask: 'Use as Mask',
            maskType: 'Mask Type',
            feather: 'Feather',
            invert: 'Invert',
            rectangle: 'Rectangle',
            circle: 'Circle',
            triangle: 'Triangle',
            ellipse: 'Ellipse',
            star: 'Star',
            polygon: 'Polygon',
            heart: 'Heart',
            clipHard: 'Clip (Hard edges)',
            alphaSoft: 'Alpha (Soft edges)',
            direction: 'Direction',
            up: 'Up',
            down: 'Down',
            left: 'Left',
            right: 'Right',
            selectShape: 'Select Shape',
            selectType: 'Select Type',
            audio: 'Audio',
            gain: 'Gain',
            fadeIn: 'Fade In',
            fadeOut: 'Fade Out',
            resetToZero: 'Reset to Zero',
            video: 'Video',
            speed: 'Speed',
            resetToOne: 'Reset to 1x',
            gif: 'GIF',
            resetOpacity: 'Reset to 100%',
            resetRadius: 'Reset to 0',
            resetPosition: 'Reset to center',
            resetRotation: 'Reset rotation',
            resetSize: 'Reset to original size',
            lockAspect: 'Lock aspect ratio',
            unlockAspect: 'Unlock aspect ratio',
            alignLeft: 'Align Left',
            alignCenterH: 'Center Horizontally',
            alignRight: 'Align Right',
            alignTop: 'Align Top',
            alignCenterV: 'Center Vertically',
            alignBottom: 'Align Bottom',
            selection: 'Selection',
            itemsSelected: 'items selected',
            adjustmentInfo: 'Effects on adjustment layers apply to all items on tracks above.',
            canvas: 'Canvas',
            swap: 'Swap',
            reset: 'Reset',
            resetToBlack: 'Reset to black',
            frameRate: 'Frame Rate',
            totalFrames: 'Total Frames',
            noProject: 'No project loaded',
            marker: 'Marker',
            markerNotFound: 'Marker not found',
            deleteMarker: 'Delete Marker',
            frame: 'Frame',
            time: 'Time',
            enterLabel: 'Enter label...',
            transition: 'Transition',
            transitionNotFound: 'Transition not found',
            timing: 'Timing',
            linear: 'Linear',
            spring: 'Spring',
            applyToAll: 'Apply to all',
            deleteTransition: 'Delete Transition',
            categoryBasic: 'Basic',
            categoryWipe: 'Wipe',
            categorySlide: 'Slide',
            categoryFlip: 'Flip',
            categorySpecial: 'Special',
            templates: 'Templates',
            exportState: 'Export current state',
            exportDescription: 'After editing the design, click this button to copy the JSON.',
        },
        // Sidebar & Media Library
        sidebar: {
            media: 'Media',
            text: 'Text',
            shapes: 'Shapes',
            effects: 'Effects',
            transitions: 'Transitions',
            templates: 'Templates',
            collapse: 'Collapse Panel',
            expand: 'Expand Panel',
            addText: 'Add Text',
            blankAdjustment: 'Blank Adjustment Layer',
            addEffectsManually: 'Add effects manually',
            colorAdjustments: 'Color Adjustments',
            glitchEffects: 'Glitch Effects',
            stylized: 'Stylized',
            presets: 'Presets',
            searchTransitions: 'Search transitions...',
            searchMedia: 'Search media...',
            import: 'Import',
            missing: 'Missing',
            itemsSelected: 'selected',
            clearSelection: 'Clear selection',
            delete: 'Delete',
            all: 'ALL',
            video: 'VIDEO',
            image: 'IMAGE',
            audio: 'AUDIO',
            sortName: 'NAME',
            sortDate: 'DATE',
            sortSize: 'SIZE',
            viewGrid: 'Grid View',
            viewList: 'List View',
            noAdjacentClip: 'No adjacent clip found. Place clips next to each other on the timeline.',
            selectSingleClip: 'Select a single video or image clip to add a transition.',
            clickToApply: 'Click a transition to apply it (will update existing).',
            confirmDeleteMedia: 'Delete selected items?',
            deleteMediaDescription: 'Are you sure you want to delete selected items? This action cannot be undone.',
            timelineClipsRemoved: 'Timeline clips will be removed',
            timelineClipsImpact: (count: number) => `${count} clip${count === 1 ? '' : 's'} in the timeline use${count === 1 ? 's' : ''} this media and will also be deleted.`,
        },
        // Effects labels
        effects: {
            brightness: 'Brightness',
            contrast: 'Contrast',
            saturate: 'Saturate',
            blur: 'Blur',
            hueRotate: 'Hue Rotate',
            grayscale: 'Grayscale',
            sepia: 'Sepia',
            invert: 'Invert',
            rgbSplit: 'RGB Split',
            scanlines: 'Scanlines',
            colorGlitch: 'Color Glitch',
            halftone: 'Halftone',
            vignette: 'Vignette',
            vintage: 'Vintage',
            noir: 'Noir',
            cold: 'Cold',
            warm: 'Warm',
            dramatic: 'Dramatic',
            faded: 'Faded',
        },
        // Settings Dialog
        settings: {
            title: 'Editor Settings',
            reset: 'Reset',
            general: 'General',
            autoSave: 'Auto-save',
            interval: 'Interval',
            timeline: 'Timeline',
            showWaveforms: 'Show Waveforms',
            showFilmstrips: 'Show Filmstrips',
            performance: 'Performance',
            undoHistoryDepth: 'Undo History Depth',
            storage: 'Storage',
            clearProjectCache: 'Clear Project Cache',
            cacheDescription: 'Waveforms, filmstrips, GIF frames, decoded audio',
            regenerateThumbnails: 'Regenerate Thumbnails',
            regenDescription: 'Re-create media library thumbnails for this project',
            deleteProxies: 'Delete Proxies',
            proxyDescription: 'Remove generated proxy videos for this project',
            clear: 'Clear',
            clearing: 'Clearing...',
            cleared: 'Cleared',
            regenerate: 'Regenerate',
            working: 'Working',
            done: 'Done',
            delete: 'Delete',
            deleting: 'Deleting...',
            deleted: 'Deleted',
            confirmClearCache: 'Clear project cache?',
            clearCacheDescription: 'This will delete cached waveforms, filmstrips, GIF frames, and decoded audio for the current project. These will be regenerated automatically when needed.',
        },
        // Unsaved Changes Dialog
        unsavedChanges: {
            title: 'Unsaved Changes',
            description: (title: string) => `You have unsaved changes in '${title}'. Would you like to save before leaving?`,
            cancel: 'Cancel',
            discard: 'Discard',
            saveAndExit: 'Save & Exit',
        },
        // Dashboard / Projects
        dashboard: {
            searchPlaceholder: 'Search projects...',
            allResolutions: 'All Resolutions',
            allFps: 'All FPS',
            importProject: 'Import Project',
            newProject: 'New Project',
            projectCount: (count: number) => `${count} project${count === 1 ? '' : 's'}`,
        },
        // Preview
        preview: {
            totalDuration: 'Total Duration',
            toggleTimecode: 'Toggle Timecode/Frames',
        },
        // Export
        export: {
            titleVideo: 'Export Video',
            titleAudio: 'Export Audio',
            exportingVideo: 'Exporting video...',
            exportingAudio: 'Exporting audio...',
            complete: 'Export complete!',
            failed: 'Export failed',
            cancelled: 'Export cancelled',
            settingsDescription: 'Configure export settings and render your video',
            progressDescription: 'Rendering your video',
            completeDescription: 'Your video is ready to download',
            errorDescription: 'Something went wrong during export',
            cancelledDescription: 'The export was cancelled',
            exportType: 'Export Type',
            video: 'Video',
            audio: 'Audio',
            range: 'Export Range',
            renderWhole: 'Render whole project',
            duration: 'Duration',
            rangeHint: 'Exporting in/out range. Toggle above to export the full timeline.',
            format: 'Format',
            selectFormat: 'Select format',
            codec: 'Codec',
            selectCodec: 'Select codec',
            quality: 'Quality',
            selectQuality: 'Select quality',
            qualityLow: 'Low (Faster, smaller file)',
            qualityMedium: 'Medium',
            qualityHigh: 'High (Recommended)',
            qualityUltra: 'Ultra (Slower, larger file)',
            resolution: 'Resolution',
            selectResolution: 'Select resolution',
            resSameAsProject: 'Same as project',
            formatDescriptionMp4: 'Most compatible, H.264/H.265',
            formatDescriptionMov: 'Best for macOS/iOS',
            formatDescriptionWebm: 'Web-optimized, VP8/VP9',
            formatDescriptionMkv: 'Flexible, all codecs',
            formatDescriptionMp3: 'Universal, small files',
            formatDescriptionAac: 'High quality, compact',
            formatDescriptionWav: 'Lossless, large files',
            audioOnlyNotice: 'Exports audio only. Video tracks will be ignored.',
            audioQualityLow: 'Low (96 kbps)',
            audioQualityMedium: 'Medium (192 kbps)',
            audioQualityHigh: 'High (256 kbps)',
            audioQualityUltra: 'Ultra (320 kbps)',
            preparing: 'Preparing...',
            rendering: 'Rendering frames...',
            encoding: 'Encoding...',
            finalizing: 'Finalizing...',
            frames: 'Frames:',
            elapsed: 'Elapsed:',
            tabOpenHint: 'Keep this tab open while rendering. Longer videos may take several minutes.',
            cancelExport: 'Cancel Export',
            successAlert: 'Video exported successfully!',
            fileSize: 'File size:',
            timeTaken: 'Time taken:',
            close: 'Close',
            download: 'Download',
            cancelProcess: 'The export process was cancelled.',
        }
    }
} as const;

export type TranslationKeys = typeof TRANSLATIONS.ko;

/**
 * Single hook to get translations based on current language setting
 */
export function useTranslation() {
    const language = useSettingsStore(s => s.language);
    return TRANSLATIONS[language] || TRANSLATIONS.ko;
}
